module.exports = __webpack_public_path__ + "static/media/5.2_preview.c24f2aff.png";